module.exports = __webpack_public_path__ + "static/media/uz.b43ab446.svg";